import { Redirect } from "react-router-dom";
import { lazy } from "react";
const FindYourTeam = lazy(() => import(/* webpackChunkName: "onboarding" */ "../components/views/connect_team/FindYourTeam.js"));
const RequestedToJoin = lazy(() => import(/* webpackChunkName: "onboarding" */ "../components/views/connect_team/RequestedToJoin.js"));
const ManageTags = lazy(() => import(/* webpackChunkName: "settings" */ "../components/views/settings/ManageTags.js"));
const InviteUsers = lazy(() => import(/* webpackChunkName: "onboarding" */ "../components/views/invitations/InviteUsers.js"));
const ProspectList = lazy(() => import(/* webpackChunkName: "prospects" */ /* webpackPrefetch: true */ "../components/views/prospects/prospectsList/index"));
const ProfileShow = lazy(() => import(/* webpackChunkName: "prospects" */ "../components/views/profiles/ProfileShow.js"));
const SmartAggregatesList = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/aggregates/smart_aggregates_list.jsx"));
const Teams = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/teams/teams"));
const SystemGeneratedPosts = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/aggregates/system_generated_posts.js"));
const TeamsDashboard = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/teams/teams_dashboard.jsx"));
const SystemConfigurationSettings = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/system_configuration/system_configuration_settings"));
const AdminPanel = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/panel.js"));
const ImportProspects = lazy(() => import(/* webpackChunkName: "prospects" */ "../components/views/prospects/import/common/ImportProspects.js"));
const ImportDetails = lazy(() => import(/* webpackChunkName: "prospects" */ "../components/views/prospects/import/common/ImportDetails.js"));
const ReviewImport = lazy(() => import(/* webpackChunkName: "prospects" */ "../components/views/prospects/import/staff/ReviewImport.js"));
const ProspectShow = lazy(() => import(/* webpackChunkName: "prospects" */ "../components/views/profiles/prospectProfile/index.jsx"));
const SimilarArticles = lazy(() => import(/* webpackChunkName: "news" */ "../components/views/news_feed/similar_articles.js"));
// import NewsFeed from '../components/views/news_feed/news_feed.js'
const RssCandidates = lazy(() => import(/* webpackChunkName: "rss" */ "../RssCandidates.js"));
const RssSources = lazy(() => import(/* webpackChunkName: "rss" */ "../rss_sources/RssSources.js"));
const Articles = lazy(() => import(/* webpackChunkName: "rss" */ "../Articles.js"));
const NewsQueries = lazy(() => import(/* webpackChunkName: "rss" */ "../NewsQueries.js"));
const ChooseTeam = lazy(() => import(/* webpackChunkName: "onboarding" */ "../components/views/connect_team/ChooseTeam.js"));
const CompleteProfile = lazy(() => import(/* webpackChunkName: "onboarding" */ "../completeProfile.js"));
const CreateTeam = lazy(() => import(/* webpackChunkName: "onboarding" */ "../components/views/connect_team/CreateTeam.js").then(m => ({ default: m.CreateTeam })));
const HelpCenterPage = lazy(() => import(/* webpackChunkName: "support" */ "../components/views/support_views/help_center/HelpCenterPage.js").then(m => ({ default: m.HelpCenterPage })));
const KnowledgeBasePage = lazy(() => import(/* webpackChunkName: "support" */ "../components/views/support_views/knowledgebase/KnowledgeBasePage.jsx"));
const TeamNewsPDFGeneration = lazy(() => import(/* webpackChunkName: "support" */ "../components/views/support_views/pdf_generation/TeamNews.js"));
const SinglePost = lazy(() => import(/* webpackChunkName: "news" */ "../components/views/news_feed/single_post"));
const TeamAdminStats = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/teams/admin_stats.js"));
const ActivityPage = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/activities/index.jsx"));
const ProspectMappings = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/prospect_mappings/ProspectMappings.js"));
const AdminCreateTeam = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/create_team/AdminCreateTeam"));
const CompaniesPage = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/companies/index.jsx").then(m => ({ default: m.CompaniesPage })));
const CategoriesPage = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/categories/index.jsx").then(m => ({ default: m.CategoriesPage })));
const FlaggedArticles = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/aggregates/flagged_articles.js"));
const ProspectInsightArticles = lazy(() => import(/* webpackChunkName: "prospects" */ "../components/views/news_feed/ProspectInsightArticles.jsx"));
const OutboundTeamsStats = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/outbound_stats/OutboundTeamsStats.jsx"));
const SearchViaKeywords = lazy(() => import(/* webpackChunkName: "search" */ "../components/views/search_feed/searchViaKeywords.js"));
const NewsSourceFeed = lazy(() => import(/* webpackChunkName: "news" */ "../components/views/news_feed/news_source_feed.js"));
const SingleRssCandidate = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/rss_candidate/SingleRssCandidate.jsx"));
// import LearnMore from "../components/views/subscribe_unsubscribe/LearnMore.jsx";
// import Features from "../components/views/subscribe_unsubscribe/Features.jsx";
// import FreePlan from "../components/views/subscribe_unsubscribe/FreePlan.jsx";
// import ContactUs from '../components/views/subscribe_unsubscribe/ContactUs.jsx';
// import PremiumPlan from "../components/views/subscribe_unsubscribe/PremiumPlan.jsx";
// import AlmaNewsLanding from "../components/landing_pages/alma_news_landing.js";
const PipeDriveApp = lazy(() => import(/* webpackChunkName: "pipedrive" */ "../components/views/subscribe_unsubscribe/pipe_drive_app.js"));
const LinkedinProspects = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/linkedin_prospects/index.jsx"));
const DataMineProspectsList = lazy(() => import(/* webpackChunkName: "data-mine" */ "../components/views/data_mine/prospects/index.jsx"));
const WebPageJobCategory = lazy(() => import(/* webpackChunkName: "data-mine" */ "../components/views/data_mine/prospects/job_category_webpage.jsx"));
const DataMineList = lazy(() => import(/* webpackChunkName: "data-mine" */ "../components/views/data_mine/lists/index.jsx"));
// import AlmaDataMine from "../components/landing_pages/alma_datamine.js";
// import { dataminePrivacyPolicy } from "../components/views/landing/dataminePrivacyPolicy.js";
const RecordingAnalytics = lazy(() => import(/* webpackChunkName: "misc" */ "../RecordingAnalytics"));
const LinkedinProspectMapping = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/linkedin_prospect_mapping/index.jsx"));
const JobUpdatesDashboard = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/job_updates_dashboard/index.jsx"));
const UserSearchSpace = lazy(() => import(/* webpackChunkName: "search" */ "../components/views/search_feed/UserSearchSpace.jsx"));
const NoAccessPage = lazy(() => import("../components/views/errors/NoAccessPage.jsx"));
const SavedSearchSpaces = lazy(() => import(/* webpackChunkName: "search" */ "../components/views/search_feed/SavedSearchSpaces.jsx"));
const RssExperiment = lazy(() => import(/* webpackChunkName: "rss" */ "../components/admin_views/rss_experiment/index.js"));
// import ExternalRedirect from "../components/utils/ExternalRedirect.js";

// import GetPremium from "../components/views/subscribe_unsubscribe/GetPremium.jsx";
const ShareDataImport = lazy(() => import(/* webpackChunkName: "misc" */ "../components/views/public_pages/_ShareDataImport.jsx").then(m => ({ default: m.ShareDataImport })));
const PipeDrivePermissions = lazy(() => import(/* webpackChunkName: "pipedrive" */ "../components/views/pipedrive/PipeDrivePermissions.jsx"));
const PipeDriveStatus = lazy(() => import(/* webpackChunkName: "pipedrive" */ "../components/views/pipedrive/PipeDriveStatus.jsx"));
const MapperSuggestions = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/mapper_suggestions/index.jsx"));
const DataExportsRedirect = lazy(() => import(/* webpackChunkName: "data-exports" */ "../components/views/data_exports/DataExportsRedirect.jsx"));
const CustomReports = lazy(() => import(/* webpackChunkName: "reports" */ "../components/views/reports/custom_reports/index.jsx"));
const CreateReportPage = lazy(() => import(/* webpackChunkName: "reports" */ "../components/views/reports/create_report.js"));
const AllReports = lazy(() => import(/* webpackChunkName: "reports" */ /* webpackPrefetch: true */ "../components/views/reports/all_reports.js"));
const NewDirectory = lazy(() => import(/* webpackChunkName: "data-mine" */ /* webpackPrefetch: true */ "../components/views/data_mine/prospects/NewDirectory.jsx"));
const HiddenLinkedinProspects = lazy(() => import(/* webpackChunkName: "data-mine" */ "../components/views/data_mine/prospects/HiddenLinkedinProspects.jsx"));
const AIReports = lazy(() => import(/* webpackChunkName: "reports" */ "../components/views/reports/index.jsx"));
const DesignSystemTestPage = lazy(() => import(/* webpackChunkName: "misc" */ "../design_system/components/Button/TestPage.jsx"));
const SettingsRedirect = lazy(() => import(/* webpackChunkName: "settings" */ "../components/views/settings/SettingsRedirect.jsx"));
const DailyPublishing = lazy(() => import(/* webpackChunkName: "daily-publishing" */ "../components/views/daily_publishing/index.jsx"));
const EmailCampaignsList = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/email_campaigns/EmailCampaignsList.jsx"));
const EmailCampaignBuilder = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/email_campaigns/EmailCampaignBuilder.jsx"));
const EmailCampaignDetail = lazy(() => import(/* webpackChunkName: "admin" */ "../components/admin_views/email_campaigns/EmailCampaignDetail.jsx"));
const routes = [
    {
        path: "/rss-candidates",
        component: RssCandidates,
        protection: ["LOGGED_IN"],
        exact: true,
        checkAuthorization: "page_rss_candidates"
    },
    {
        path: "/rss-sources",
        component: RssSources,
        protection: ["LOGGED_IN"],
        exact: true,
        checkAuthorization: "page_rss_sources"
    },
    {
        path: "/articles",
        component: Articles,
        protection: ["LOGGED_IN"],
        checkAuthorization: "page_articles"
    },
    {
        path: "/news_queries",
        component: NewsQueries,
        protection: ["LOGGED_IN", "IS_ADMIN"],
    },
    {
        path: "/connect_teams",
        component: ChooseTeam,
        protection: ["LOGGED_IN"],
        layout: "pre-auth-layout"
    },
    {
        path: "/complete_profile",
        component: CompleteProfile,
        protection: ["LOGGED_IN", "HAS_NOT_SELECTED_TEAM"],
        layout: "pre-auth-layout"
    },
    {
        path: "/find_team",
        component: FindYourTeam,
        protection: ["LOGGED_IN"],
        layout: "pre-auth-layout"
    },
    {
        path: "/create_team",
        component: CreateTeam,
        protection: ["LOGGED_IN"],
        layout: "pre-auth-layout"
    },
    {
        path: "/requested",
        component: RequestedToJoin,
        protection: ["LOGGED_IN"],
        layout: "pre-auth-layout"
    },
    {
        path: "/prospects/archived",
        component: ProspectList,
        protection: ["LOGGED_IN"],
    },
    {
        path: "/prospects/:prospect_id",
        component: ProspectShow,
        protection: ["LOGGED_IN"],
    },
    {
        path: '/prospect_articles/:prospect_id',
        component: ProspectInsightArticles,
        protection: ["LOGGED_IN"]
    },
    {
        path: "/:article_id/similar_articles",
        component: SimilarArticles,
        protection: ["LOGGED_IN"],
    },
    {
        path: "/post/:post_id",
        component: SinglePost,
        protection: ["LOGGED_IN"],
    },
    {
        path: "/news_source/:source/feed",
        component: NewsSourceFeed,
        protection: ["LOGGED_IN"],
        layout: "feed-layout",
    },
    // {
    //   path: '/feed',
    //   component: NewsFeed
    //
    // },
    {
        path: "/pipe_drive",
        component: PipeDriveApp,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"

    },
    {
        path: "/prospects",
        component: ProspectList,
        protection: ["LOGGED_IN"],
        trackPageVisit: true
    },
    {
        path: "/import_prospects/:id/review",
        component: ReviewImport,
        protection: ["LOGGED_IN"],
        checkAuthorization: "prospect_data_import",
        layout: "compact-layout",
    },
    {
        path: "/import_prospects/:id",
        component: ImportDetails,
        protection: ["LOGGED_IN"],
        checkAuthorization: "prospect_data_import",
    },
    {
        path: "/import_prospects",
        component: ImportProspects,
        protection: ["LOGGED_IN"],
        checkAuthorization: "prospect_data_import",
        layout: "compact-layout",
    },
    {
        path: "/manage/tags",
        component: ManageTags,
        protection: ["LOGGED_IN"],
    },

    {
        path: "/invite_users",
        component: InviteUsers,
        protection: ["LOGGED_IN"],
        layout: "pre-auth-layout"
    },
    {
        path: "/profile/:profile_id",
        component: ProfileShow,
        protection: ["LOGGED_IN"],
    },
    {
        path: "/admin/panel",
        component: AdminPanel,
        protection: ["LOGGED_IN"],
        checkAuthorization: "super_admin_panel"
    },
    {
        path: "/admin/email_campaigns/new",
        component: EmailCampaignBuilder,
        protection: ["LOGGED_IN", "IS_PUBLISHER_PLUS"],
        exact: true,
        layout: "blank-layout email-campaign-layout"
    },
    {
        path: "/admin/email_campaigns/:id",
        component: EmailCampaignDetail,
        protection: ["LOGGED_IN", "IS_PUBLISHER_PLUS"],
        exact: true,
        layout: "blank-layout email-campaign-layout"
    },
    {
        path: "/admin/email_campaigns",
        component: EmailCampaignsList,
        protection: ["LOGGED_IN", "IS_PUBLISHER_PLUS"],
        exact: true,
        layout: "blank-layout email-campaign-layout"
    },
    {
        path: "/admin/smart_publish",
        component: SmartAggregatesList,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_smart_publish",
        layout: "compact-layout"
    },
    {
        path: "/admin/flagged_articles",
        component: FlaggedArticles,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_flagged_articles"
    },
    {
        path: "/admin/activities",
        component: ActivityPage,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_team_user_activities"
    },
    {
        path: "/admin/teams",
        component: Teams,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_teams"
    },
    {
        path: "/admin/system_generated_posts",
        component: SystemGeneratedPosts,
        protection: ["LOGGED_IN"],
        checkAuthorization: "page_system_generated_posts"
    },
    {
        path: "/admin/teams_dashboard",
        component: TeamsDashboard,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_teams_dashboard"
    },
    {
        path: "/admin/team_stats",
        component: TeamAdminStats,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_team_stats"
    },
    {
        path: "/admin/system_configuration",
        component: SystemConfigurationSettings,
        protection: ["LOGGED_IN", "IS_SUPER_ADMIN"],
    },
    {
        path: "/admin/outbound_stats",
        component: OutboundTeamsStats,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_outbound_stats"
    },
    {
        path: "/admin/prospect_mappings",
        component: ProspectMappings,
        protection: ["LOGGED_IN"],
        checkAuthorization: "page_prospect_mappings"
    },
    {
        path: "/admin/create_team",
        component: AdminCreateTeam,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "team_creating"
    },
    {
        path: "/admin/companies",
        component: CompaniesPage,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        checkAuthorization: "page_companies"
    },
    {
        path: "/admin/categories",
        component: CategoriesPage,
        protection: ["LOGGED_IN"],
        checkAuthorization: "page_categories"
    },
    {
        path: "/admin/linkedin_prospects",
        component: LinkedinProspects,
        protection: ["LOGGED_IN"],
        checkAuthorization: "page_linkedin_prospects"
    },
    {
        path: "/help_center",
        component: HelpCenterPage,
        layout: "pre-auth-layout-no-space",
        protection: [],
    },
    {
        path: "/knowledgebase",
        component: KnowledgeBasePage,
        protection: ["LOGGED_IN"],
        exact: true
    },
    /* Landing pages are handled by early redirect in App.js
    {
        path: "/",
        component: AlmaNewsLanding,
        layout: "pre-auth-layout-no-space landing_header_no_overlap",
        exact: true
    },    
    */
    {
        path: "/pdf_generation/team_news",
        component: TeamNewsPDFGeneration,
        protection: [],
    },
    {
        path: "/search_articles/keyword_term_search",
        component: SearchViaKeywords,
        protection: ["LOGGED_IN"],
        checkAuthorization: "page_search_space",
        accessDeniedComponent: NoAccessPage,
    },
    {
        path: "/rss-candidates/:id/external_article",
        component: SingleRssCandidate,
        protection: ["LOGGED_IN"],
        exact: true,
    },
    /* Landing pages are handled by early redirect in App.js
    {
        path: "/learn_more",
        component: LearnMore,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    {
        path: "/features",
        component: Features,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    {
        path: "/plans",
        component: FreePlan,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    {
        path: "/contact_us",
        component: ContactUs,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    {
        path: "/premium",
        component: PremiumPlan,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    {
        path: "/get_premium",
        component: GetPremium,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    */
    {
        path: "/team/webpage_jobs",
        component: WebPageJobCategory,
        exact: true,
        protection: ["LOGGED_IN"],
        layout: "feed-layout"
    },
    {
        path: "/team/lists",
        component: DataMineList,
        exact: true,
        protection: ["LOGGED_IN"],
        layout: "blank-layout"
    },
    {
        path: "/team/lists/:list_id",
        component: DataMineProspectsList,
        exact: true,
        protection: ["LOGGED_IN"],
        layout: "blank-layout"
    },
    /* Landing pages are handled by early redirect in App.js
    {
        path: "/data_mine",
        component: AlmaDataMine,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    {
        path: "/data_mine/privacy_policy",
        component: dataminePrivacyPolicy,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    */
    {
        path: "/pageviewing",
        component: RecordingAnalytics,
        exact: true,
        layout: "pre-auth-layout-no-space landing_header_no_overlap"
    },
    {
        path: "/admin/linkedin_prospect_mapping",
        component: LinkedinProspectMapping,
        protection: ["LOGGED_IN"],
        checkAuthorization: "page_linkedin_prospect_mapping"
    },
    {
        path: "/admin/job_updates_dashboard",
        component: JobUpdatesDashboard,
        protection: ["LOGGED_IN"],
        checkAuthorization: "job_updates_dashboard"
    },
    {
        path: "/search/:id",
        component: UserSearchSpace,
        protection: ["LOGGED_IN"],
        layout: "feed-layout",
        checkAuthorization: "page_search_space",
        accessDeniedComponent: NoAccessPage,
    },
    {
        path: "/search",
        component: UserSearchSpace,
        protection: ["LOGGED_IN"],
        layout: "feed-layout",
        checkAuthorization: "page_search_space",
        accessDeniedComponent: NoAccessPage,
    },
    {
        path: "/saved_searches",
        component: SavedSearchSpaces,
        protection: ["LOGGED_IN"],
        layout: "feed-layout",
        checkAuthorization: "page_search_space",
        accessDeniedComponent: NoAccessPage,
    },
    {
        path: "/directory",
        component: NewDirectory,
        exact: true,
        protection: ["LOGGED_IN"],
        requiresDirectoryFeature: true,
        layout: "blank-layout",
        trackPageVisit: true
    },
    {
        path: "/directory/hidden",
        component: HiddenLinkedinProspects,
        exact: true,
        protection: ["LOGGED_IN", "IS_ADMIN"],
        requiresDirectoryFeature: true,
        layout: "blank-layout",
    },
    {
        path: "/rss-experiments",
        component: RssExperiment,
        protection: ["LOGGED_IN"],
        exact: true,
        checkAuthorization: "page_rss_experiments"
    },
    {
        // The page controls its own height and scrolling.
        path: "/admin/temp-mapper",
        component: MapperSuggestions,
        protection: ["LOGGED_IN", "HAS_SELECTED_TEAM"],
        exact: true,
        checkAuthorization: "page_temp_mappers",
        layout: "flush-layout"
    },
    {
        path: "/mapper-suggestions",
        component: MapperSuggestions,
        protection: ["LOGGED_IN"],
        exact: true,
        requiresMapperFeature: true,
        layout: "flush-layout"
    },
    {
        path: "/import_data",
        component: ShareDataImport,
        exact: true,
        layout: "pre-auth-layout"
    },
    {
        path: "/pipedrive-permission",
        component: PipeDrivePermissions,
        protection: ["LOGGED_IN"],
        exact: true,
        layout: "blank-layout"
    },
    {
        path: "/pipedrive-installation",
        component: PipeDriveStatus,
        protection: ["LOGGED_IN"],
        exact: true,
        layout: "blank-layout"
    },
    {
        path: "/data-exports",
        component: DataExportsRedirect,
        protection: ["LOGGED_IN", "HAS_SELECTED_TEAM"],
        exact: true,
        requiresAnyExportPermission: true,
        layout: "blank-layout"
    },
    {
        path: "/reports",
        component: AllReports,
        exact: true,
        protection: ["LOGGED_IN"],
        requiresReportsFeature: true,
        layout: "blank-layout"
    },
    {
        path: "/reports/ai-report/:id",
        component: AIReports,
        exact: true,
        protection: ["LOGGED_IN"],
        requiresReportsFeature: true,
        layout: "flush-layout"
    },
    {
        path: "/create_report",
        component: CreateReportPage,
        exact: true,
        protection: ["LOGGED_IN"],
        requiresReportsFeature: true,
        layout: "default-layout",
        trackPageVisit: true
    },
    {
        path: "/new-directory",
        component: () => <Redirect to="/directory" />,
        exact: true,
        protection: ["LOGGED_IN"],
        layout: "blank-layout"
    },
    {
        path: "/reports/custom-report/:id",
        component: CustomReports,
        exact: true,
        protection: ["LOGGED_IN"],
        requiresReportsFeature: true,
        layout: "blank-layout"
    },
    {
        path: "/daily-publishing",
        component: DailyPublishing,
        exact: true,
        protection: ["LOGGED_IN", "IS_PUBLISHER"],
        layout: "blank-layout",
        checkAuthorization: "page_daily_publishing"
    },
    {
        path: "/design-system",
        component: DesignSystemTestPage,
        exact: true,
        protection: ["LOGGED_IN","IS_SUPER_ADMIN"],
        layout: "blank-layout"
    },
    {
        path: "/settings/:settingsPage?",
        component: SettingsRedirect,
        protection: ["LOGGED_IN"],
    }
];

export default routes;
